import { Home } from '../pages/Home'
import { Programas } from '../pages/Programas'
import { Doctorados } from '../components/Programas/Doctorados';
import { ItemDoctorado } from '../components/Programas/ItemDoctorado';
import { Maestrias } from '../components/Programas/Maestrias';
import { ItemMaestria } from '../components/Programas/ItemMaestria';
import { Especialidades } from '../components/Programas/Especialidades';
import { ItemEspecialidad } from '../components/Programas/ItemEspecialidad';
import { Sedes } from '../components/Programas/Sedes';
import { Contacto } from '../pages/Contacto';
import { Direccion } from '../pages/Direccion';
import { ConsejoTecnico } from '../pages/ConsejoTecnico';
import { TramitesDireccion } from '../pages/subpages/TramitesDireccion';
import { TramitesConsejoTec } from '../pages/subpages/TramitesConsejoTec';
import { InstructivosConsejoTec } from '../pages/subpages/InstructivosConsejoTec';
import { SecretariaDocente } from '../pages/SecretariaDocente';
import { CursosPEC } from '../pages/CursosPEC';
import { PecProgramasFrecuentes } from '../pages/subpages/PEC_ProgramasFrecuentes';
import { PecCursosPermanentes } from '../pages/subpages/PEC_CursosPermanentes';
import { PecTramites } from '../pages/subpages/PEC_Tramites';
import { Concursos } from '../pages/Concursos';
import { ConcursosNormativa } from '../pages/subpages/ConcursosNormativa';
import { ConcursosListados } from '../pages/subpages/ConcursosListados';
import { ConcursosTramites } from '../pages/subpages/ConcursosTramites';
import { ControlEstudios } from '../pages/ControlEstudios';
import { AcreditacionCurriculo } from '../pages/AcreditacionCurriculo';
import { Archivo } from '../pages/Archivo';
import { ArchivoTramites } from '../pages/subpages/ArchivoTramites';
import { ArchivoSolicitudRetiro } from '../pages/subpages/ArchivoSolicitudRetiro';
import { Administracion } from '../pages/Administracion';
import { AdministracionTramites } from '../pages/subpages/AdministracionTramites';
import { Facultad } from '../pages/Facultad';
import { RelacionesPublicas } from '../pages/RRPP';
import { Informatica } from '../pages/Informatica';
import { Comites, ItemComite } from '../pages/Comites';
import { ConcursoDoctorados } from '../pages/subpages/ConcursoDoctorados';
import { ConcursoPrueba } from '../pages/subpages/ConcursoPrueba';
import { CheckUbicacion } from '../pages/subpages/CheckUbicacion';
import { ConcursoInscripciones } from '../pages/subpages/ConcursoInscripciones';
import { ItemProgFrecuentes } from '../pages/childrenComponents/ItemProgFrecuentes';
import { ConcursoResena } from '../pages/subpages/ConcursoResena';
import { Navigate } from 'react-router-dom';
import { ConcursoListadoProvisional } from '../pages/subpages/ConcursoListadoProvisional';
import { ConcursoListadoProvViewer } from '../pages/subpages/ConcursoListadoProvViewer';

const routes = [
    {
        title: 'Posgrado',
        path: 'posgrado',
        isActive: true,
        component: <Programas/>,
        children: [
            {
                title: 'Doctorados',
                path: 'doctorados',
                isActive: true,
                component: <Doctorados/>,
                index: 2,
                childrenCompontent: <ItemDoctorado />,
            },
            {
                title: 'Maestrías',
                path: 'maestrias',
                isActive: true,
                component: <Maestrias />,
                index: 1,
                childrenCompontent: <ItemMaestria />
            },
            {
                title: 'Especialidades',
                path: 'especialidades',
                isActive: true,
                component: <Especialidades />,
                index: 0,
                childrenCompontent: <ItemEspecialidad />
            },
            {
                title: 'Unidades Docentes (Sedes)',
                path: 'unidades-docentes',
                isActive: true,
                component: <Sedes />,
                index: 3
            },
        ]
    },
    {
        title: 'Contacto',
        path: 'contacto',
        isActive: true,
        component: <Contacto/>
    },
    {
        title: 'Home',
        path: '/',
        isActive: true,
        component: <Home/>
    },
    {
        title: 'Dirección',
        path: 'direccion',
        isActive: true,
        component: <Direccion />,
        children: [
            {
                title: "Trámites",
                path: "tramites",
                isActive: true,
                component: <TramitesDireccion />
            }
        ]
    },
    {
        title: 'Consejo Técnico',
        path: 'consejo-tecnico',
        isActive: true,
        component: <ConsejoTecnico />,
        children: [
            {
                title: "Trámites",
                path: "tramites",
                isActive: true,
                component: <TramitesConsejoTec />
            },
            {
                title: "Instructivos Presenciales",
                path: "instructivos",
                isActive: true,
                component: <InstructivosConsejoTec />
            },
        ]
    },
    {
        title: 'Secretaría Docente',
        path: 'secretaria-docente',
        isActive: true,
        component: <SecretariaDocente />
    },
    {
        title: 'Cursos PEC',
        path: 'cursos-pec',
        isActive: true,
        component: <CursosPEC />,
        children: [
            {
                title: 'Programas Frecuentes',
                path: 'programas-frecuentes',
                isActive: true,
                component: <PecProgramasFrecuentes />,
                childrenCompontent: <ItemProgFrecuentes />
            },
            {
                title: 'Cursos Permanentes',
                path: 'cursos-permanentes',
                isActive: true,
                component: <PecCursosPermanentes />
            },
            {
                title: 'Trámites y Solicitudes',
                path: 'tramites-solicitudes',
                isActive: true,
                component: <PecTramites />
            }
        ]
    },
    {
        title: 'Concurso 2026',
        longTitle: 'Concurso Posgrado Medicina 2026',
        path: 'concurso',
        isActive: true,
        component: <Concursos />,
        children: [
            {
                title: 'Doctorados',
                displayTitle: 'Concurso Doctorados 2026',
                path: 'doctorados',
                active: true,
                isActive: true,
                component: <ConcursoDoctorados />
            },
            {
                title: 'Reseña',
                displayTitle: 'Reseña',
                path: 'descripcion',
                active: true,
                isActive: true,
                component: <ConcursoResena />
            },
            {
                title: 'Normativa',
                displayTitle: 'Normativa que rige el proceso',
                path: 'normativa',
                active: true,
                isActive: true,
                component: <ConcursosNormativa />
            },
            {
                title: 'Listados',
                path: 'listados',
                active: false,
                isActive: false,
                component: <ConcursosListados />
            },
            {
                title: 'Trámites',
                path: 'tramites',
                active: false,
                isActive: false,
                component: <ConcursosTramites />,
                children: [
                    {
                        title: 'Registro al Concurso',
                        path: 'registro',
                        disabled: false,
                        active: true,
                        component: <></>
                    },
                    {
                        title: 'Reconsideraciones',
                        path: 'reconsideraciones',
                        disabled: true,
                        active: false,
                        component: <></>
                    },
                    {
                        title: 'Inscripción',
                        path: 'inscripcion',
                        disabled: true,
                        active: false,
                        component: <></>
                    }
                ]
            },
            {
                title: 'Examen de Conocimientos',
                displayTitle: 'Examen de Conocimientos',
                path: 'prueba-conocimientos',
                active: true,
                isActive: true,
                component: <ConcursoPrueba />
            },
            {
                title: 'Listado Provisional',
                displayTitle: 'Listado Provisional',
                path: 'listado-provisional',
                active: true,
                isActive: true,
                component: <ConcursoListadoProvisional />
            },
            {
                title: 'Listado de Ganadores',
                displayTitle: 'Listado de Ganadores',
                path: 'listado-ganadores',
                active: false,
                isActive: false,
                component: <ConcursoInscripciones />
            },
            {
                title: 'Listado Provisional Concurso 2026',
                displayTitle: 'Listado Provisional - Concurso DEPGFMLUZ 2026',
                path: 'listado-provisional-concurso',
                active: false,
                isActive: true,
                hideOverlay: true,
                component: <ConcursoListadoProvViewer />
            }
        ]
    },
    {
        title: 'Control de Estudios',
        path: 'control-estudios',
        isActive: true,
        component: <ControlEstudios />
    },
    {
        title: 'Acreditación y Currículo',
        path: 'acreditacion-curriculo',
        isActive: true,
        component: <AcreditacionCurriculo />
    },
    {
        title: 'Archivo',
        path: 'archivo',
        isActive: true,
        component: <Archivo />,
        children: [
            {
                title: 'Trámites y Solicitudes',
                path: 'tramites',
                isActive: true,
                component: <ArchivoTramites />,
                childrenCompontent: <ArchivoSolicitudRetiro />
            }
        ]
    },
    {
        title: 'Administración',
        path: 'administracion',
        isActive: true,
        component: <Administracion />,
        children: [
            {
                title: 'Trámites y Solicitudes',
                path: 'tramites',
                isActive: true,
                component: <AdministracionTramites />
            }
        ]
    },
    {
        title: 'Facultad de Medicina',
        path: 'facultad-de-medicina',
        isActive: true,
        component: <Facultad />
    },
    {
        title: 'Relaciones Públicas',
        path: 'relaciones-publicas',
        isActive: true,
        component: <RelacionesPublicas />
    },
    {
        title: 'Departamento de Informática',
        path: 'informatica',
        isActive: true,
        component: <Informatica />
    },
    {
        title: 'Comités Académicos',
        path: 'comites-academicos',
        isActive: true,
        component: <Comites />,
        variableChildren: true,
        children: [
            { 
                title: 'Item Comité',
                isActive: true,
                component: <ItemComite />
            }
        ]
    },
    {
        title: 'Check Ubicaciones',
        path: 'ubicaciones-concurso',
        isActive: true,
        component: <CheckUbicacion />
    },
    {
        title: '404 No Encontrado',
        path: '*',
        isActive: true,
        component: <Navigate to={'/'} replace />
    }
]

export default routes;